<template>
	<div class="flex flex-col min-h-[80vh] p-6 gap-6 justify-center text-center">
		<a
			href="https://arda.digital/"
			target="_blank"
			class="text-center"
		>
			<img
				src="@/assets/black_ARDA_logo.svg"
				alt="ARDA"
				class="max-w-xs w-full mx-auto"
			>
		</a>
		<div class="max-w-3xl mx-auto">
			<h2 class="text-2xl font-semibold mb-3">
				Спасибо за регистрацию вашей компании в нашем портале!
			</h2>
			Мы получили вашу заявку и отправили ее на рассмотрение нашим модераторам. Они скоро ее рассмотрят, и мы сообщим вам о результатах на указанный
			вами адрес электронной почты. <br>
			Спасибо за ваше терпение и интерес к нашему порталу!
		</div>
	</div>
</template>

<script>
export default {
	name: "RegistrationCompanySuccess"
};
</script>

<style scoped>

</style>